import React from 'react';

import styles from './styles.module.css';

export const Spinner = () => {
  return <div className={styles.spinner} />;
};
